import { Dispatch, FC, SetStateAction } from 'react'
import TabPanel from '../../../components/LibraryDetailsTabPanel'
import Devices from '../../devices/Devices'
import { DevicesTabs } from '../../../useLibraryDetailsData'
import { useLibraryDetails } from 'contexts/LibraryDetailsContext'
import { ColumnValue, DevicesQueryPagination, DevicesQueryPayload } from 'models'

interface DevicesTabPanelProps {
  columnValues: ColumnValue[]
  setColumnValues: Dispatch<SetStateAction<ColumnValue[]>>
  getLookup: (columnId: string) => Promise<string[]>
  devicesPagination: DevicesQueryPagination
  thisCpiName: string
  fetchQuery: ({ page, payload }: { page?: number; payload?: DevicesQueryPayload }) => Promise<any>
  customerName: string
  setColumnsFetched: (value: boolean) => void
}

export const DevicesTabPanel: FC<DevicesTabPanelProps> = ({
  columnValues,
  getLookup,
  devicesPagination,
  thisCpiName,
  fetchQuery,
  setColumnValues,
  customerName,
  setColumnsFetched
}) => {
  const { tabValue, snowflakeManifest } = useLibraryDetails()

  return (
    <TabPanel
      value={
        snowflakeManifest && tabValue === DevicesTabs.OperationalView
          ? 1
          : snowflakeManifest && tabValue === DevicesTabs.OperationalView
          ? 1
          : 10
      }
      index={1}
    >
      <Devices
        setColumnValues={setColumnValues}
        columnValues={columnValues}
        getLookup={getLookup}
        devicesPagination={devicesPagination}
        thisCpiName={thisCpiName}
        fetchQuery={fetchQuery}
        customerName={customerName}
        setColumnsFetched={setColumnsFetched}
      />
    </TabPanel>
  )
}
